




















































































import { Component, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import MyProjects from '@/views/home/home-my-projects.component.vue';
import SearchBar from '@/views/home/home-search-bar.component.vue';
import RecentProjects from '@/views/home/home-recent-projects.component.vue';
import ProjectUserStore from '@/domain/project/project-with-members.store';
import HomeButton from '@/shared/button/button.component.vue';
import ProjectModal from '@/views/project/project-modal.component.vue';
import McpAnnouncement from '@/views/home/home-mcp-announcement.component.vue';
import Icons from '@/shared/icons/icons.json';
import ProjectWithMembers from '@/domain/project/project-with-members.entity';
import {
  hasAdministratorAuthority,
} from '@/shared/directive/has-authority.directive';
import ProjectPersist from '../../domain/project/project-persist.entity';

@Component({
  components: {
    'my-projects': MyProjects,
    'search-bar': SearchBar,
    'recent-projects': RecentProjects,
    'home-button': HomeButton,
    'project-modal': ProjectModal,
    'mcp-announcement': McpAnnouncement,
  },
  directives: {
    hasAdministratorAuthority,
  },
})
export default class Home extends Vue {
  private projectsStore = getModule(ProjectUserStore);

  private dialog: boolean = false;

  private projectModalKey: number = 0;

  private editingProject: boolean = false;

  private newProject: ProjectPersist = new ProjectPersist();

  private search = '';

  private icons: any[] = Icons;

  private loading: boolean = true;

  created() {
    this.refreshProjects();
  }

  get projectsUserList() {
    if (this.search) {
      return this.projectsStore.getAllProjectsUser
        .filter(project => project.name.toLowerCase().includes(this.search.toLowerCase().trim()));
    }
    return this.projectsStore.getAllProjectsUser;
  }

  get recentProjects() {
    return this.projectsUserList.slice(0, 3);
  }

  get allProjects() {
    return this.projectsUserList.slice(3);
  }

  refreshProjects() {
    this.search = '';
    this.projectsStore.fetchProjects().then(() => {
      this.loading = false;
    });
  }

  setLoadingAndRefreshProjects() {
    this.loading = true;
    this.refreshProjects();
  }

  private rerenderProjectModal(): void {
    this.projectModalKey += 1;
  }

  private openModalForNewProject(): void {
    this.dialog = true;
    this.newProject = new ProjectPersist();
    this.editingProject = false;
    this.rerenderProjectModal();
  }

  close() {
    this.dialog = false;
    this.setLoadingAndRefreshProjects();
  }

  private openEditProjectModal(project: ProjectWithMembers): void {
    this.dialog = true;
    this.newProject = new ProjectPersist({
      id: project.id,
      name: project.name,
      description: project.description,
      projectUsers: project.members.map(member => member.user),
      members: project.members,
      businessUnitId: project.businessUnitId,
      costCenterId: project.costCenterId,
      manager: project.manager,
    });
    this.editingProject = true;
    this.rerenderProjectModal();
  }
}
